export const ACTION_RESET = 'FETCH_REGION_RESET';
export const ACTION_REQUEST = 'FETCH_REGION_REQUEST';
export const ACTION_SUCCESS = 'FETCH_REGION_SUCCESS';
export const ACTION_ERROR = 'FETCH_REGION_ERROR';
